var parent = require('../../es/typed-array');

module.exports = parent;
